import { useEffect, useMemo, useState } from "react";

import { useSelectorTrigger } from "app/components/filters-bar/useSelectorTrigger";
import { TrafficTopCountries } from "app/components/TrafficTopCountries/TrafficTopCountries";
import type { ICountryTrafficShare } from "app/pages/website-performance/components/TopCountries/type";
import DurationService from "app/services/DurationService";
import { DefaultFetchService } from "app/services/fetchService";

const fetchService = DefaultFetchService.getInstance();
const endpoint = "widgetApi/WebsiteGeography/Geography/Table";
const TitleKey = "ia.overview.geography";
const ToolTipKey = "wwo.geography.tooltip";

interface ICountryTrafficShareData {
    Country: number;
    Share: number;
    Change: number;
    ShareList: Record<string, number>;
}

const WWOTrafficTopCountries = ({ params, getCtaLink, unlockHook = null, hideFooter = false }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [countriesTrafficShare, setCountriesTrafficShare] = useState<ICountryTrafficShare[]>([]);
    const { selectorHandlers } = useSelectorTrigger("traffic-top-countries");
    const { from, to, isWindow } = useMemo(() => DurationService.getDurationData(params.duration).forAPI, []);

    const siteNames = useMemo(() => params.key.split(","), []);
    const isCompare = siteNames.length > 1;

    const ctaHref = getCtaLink();

    useEffect(() => {
        setIsLoading(true);
        (async () => {
            try {
                const { Data: countriesData } = await fetchService.get<{
                    Data: ICountryTrafficShareData[];
                }>(endpoint, {
                    country: 999,
                    includeSubDomains: params.isWWW === "*",
                    webSource: params.webSource,
                    timeGranularity: isWindow ? "Daily" : "Monthly",
                    orderBy: "TotalShare desc",
                    keys: params.key,
                    pageSize: 5,
                    from,
                    to,
                    isWindow,
                });

                const countriesDataFormatted: ICountryTrafficShare[] = countriesData.map((country) => ({
                    country: country.Country,
                    share: country.Share,
                    shareList: country.ShareList,
                    change: country.Change,
                }));
                setCountriesTrafficShare(countriesDataFormatted);
            } catch (e) {}
            setIsLoading(false);
        })();
    }, []);
    return (
        <TrafficTopCountries
            countriesTrafficShare={countriesTrafficShare}
            ctaHref={ctaHref}
            isLoading={isLoading}
            isCompare={isCompare}
            unlockHook={unlockHook}
            params={params}
            textKeys={{ titleKey: TitleKey, titleTooltipKey: ToolTipKey }}
            hideFooter={hideFooter}
            onDateClick={selectorHandlers.onDateClick}
            onDateHover={selectorHandlers.onDateHover}
            onWebSourceHover={selectorHandlers.onWebSourceHover}
        />
    );
};

export default WWOTrafficTopCountries;
